

export default {
	components: {
		Navbar: () => import('../navbar/Navbar.vue'),
		Drawer: () => import('../drawer/Drawer.vue'),
		SecondaryDrawer: () => import('../drawer/SecondaryDrawer.vue'),
		// ManageDrawer: () => import('../drawer/ManageDrawer.vue'),
		MainBody: () => import('../MainBody.vue'),
		// Footer: () => import('../footer/Footer.vue'),
		Snakebar: () => import('@/components/common-components/Snakebar.vue'),
		PageLoader: () => import('@/components/common-components/PageLoader.vue'),
	},
	methods:{
		openNav() {
			document.getElementById("mySidenav").style.width = "156px";
			document.getElementById("main").style.marginLeft = "156px";
		},
		closeNav() {
			document.getElementById("mySidenav").style.width = "0";
			document.getElementById("main").style.marginLeft= "0";
		}
	}
}